import { v4 as uuidv4 } from "uuid";
export class TimeReportEntryModel {
    constructor() {
        this.id = uuidv4();
        this.startTime = null;
        this.endTime = null;
        this.description = "";
        this.employeeId = null;
        this.employeeName = "";
        this.startTimeTzFormatted = "";
        this.endTimeTzFormatted = "";
        this.startTimeAsString = "";
        this.totalTimeInHours = "";
        this.totalTime = "";
        this.totalTimeInSeconds = 0;
        this.projectDisplayString = "";
        this.taskDisplayString = "";
        this.taskDescription = "";
    }
}
export default class TimeReportEntry extends TimeReportEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
